export const environment = {
  production: false,
  serverUrl: 'https://jdr.agence-laika.fr/api',
  API_KEY_PIXABAY: ''
};
